import { bindable } from 'aurelia-framework';
import { ISetActionableParams } from './import-entry-buttons';

export class CancelImportButton {
	@bindable setActionable: (params: ISetActionableParams) => void;
	@bindable cancelImport: () => void;
	@bindable cancelImportKeepAutomationResults: () => void;
	confirmVisible = false;

	toggleConfirm() {
		this.confirmVisible = !this.confirmVisible;
		this.setActionable({ actionable: this.confirmVisible });
	}
}
